import {React,useEffect, useState} from 'react';
import style from './auth.module.scss';
import {IMG_URL} from '../../../configuration/apiconfig';
import AppInfoservice from '../../../service/common/Appinfo';

const Brand = () => {
    const [logo,setLogo]=useState()
    const service = new AppInfoservice();
    

    useEffect(()=>{
        service.Appinfo().then((res)=>{
            if(res.status){
            //   setLogo(res.data.company_info.login_logo)
              setLogo(res.data.company_info.favicon)
            }else{
                
            }
        })  
    },[])

    return (
        
        <div className={`d-block mt-2 ${style.loginNavBrand}`}>
            <img src={IMG_URL+"logos/"+logo} alt="" className={style.loginNavBrandImg}/>
        </div>
    );
};

export default Brand; 